export default "__VITE_ASSET__VA72cEkP__"